<form *ngIf="form" [formGroup]="form">

  <dx-date-box formControlName="date"         formField required [label]="'common.date' | translate | ucfirst" type="date"/>
  <dx-text-area formControlName="description" formField required [label]="'entity.product.description' | translate | ucfirst"/>
  <dx-text-box formControlName="reference"  formField [label]="'entity.consignmentStock.reference' | translate | ucfirst"></dx-text-box>
  <dx-text-box formControlName="cost"         formField required [label]="'entity.cost' | translate | ucfirst"/>

  <dx-lookup 
    [gsResource]="organizationsRes" 
    formField
    formControlName="organizationId" valueExpr="id" displayExpr="legalName"
    [label]="'entity.organization.organization' | translate | ucfirst"
    />
</form>